
import api from '@/helpers/api'


const API_READ = `/api/corporate/`
const API_UPDATE = API_READ
const API_CREATE = API_READ
const API_DELETE = API_READ
const API_READ_LOGO = `/api/corp-logo/`;


export default {
  namespaced: true,
  state: {
    status: '',
    corporates: [],
    meta: {
      page: 1,
      limit: 10,
      total: 1
    },
    filter: {}
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    read(state, { corporates }) {
      state.corporates = [...corporates]
    },
    error(state) {
      state.status = 'error'
    },
    success(state) {
      state.status = 'success'
    },

    read_single_success(state, { corporate }) {
      state.corporate = corporate
    },

    switch_page(state, { meta }) {
      state.meta = { ...meta }
    },
    add_filter(state, { filter }) {
      state.filter = filter;
    },
    set_search(state, { search }) {
      state.search = { ...search };
    },
    clear_search(state) {
      state.search = {};
    },
    reset_meta(state) {
      state.meta = {
        limit: 10,
        page: 1,
        total: 1,
      }
    }
  },
  actions: {
    read({ commit, state }) {
      commit('request');
      const { meta } = state
      const { filter } = state
      const { search } = state

      return new Promise((resolve, reject) => {
        api.request('get', API_READ, { meta, filter, search })
          .then((result) => {
            commit('read', { corporates: result.data.data })
            commit('success')

            commit('switch_page', { meta: { ...result.data.meta } })
            return resolve()
            // }).catch((err) => {
          }).catch((err) => {
            commit('error')
            return reject(err)
          }).finally(() => {
          });
      })
    },
    delete({ commit, dispatch, state }, id) {
      commit('request');

      // Check if this is the last item on current page (before delete)
      const itemsCount = state.corporates.length;
      const currentPage = state.meta.page;
      const willBeEmpty = itemsCount === 1 && currentPage > 1;

      return new Promise((resolve, reject) => {

        api.request('delete', `${API_DELETE}${id}`, {})

          .then((response) => {
            // If page will be empty after delete, navigate to previous page first
            if (willBeEmpty) {
              const newMeta = { ...state.meta, page: currentPage - 1 };
              commit('switch_page', { meta: newMeta });
            }

            // Reload data
            dispatch('read');
            return resolve(response)
          }).catch((err) => {
            console.log(err.response.data);
            commit('success')
            return reject(err)
          }).finally(() => {
            // page.isLoading = false;
          });
      })
    },
    read_single({ commit }, id) {
      commit('request');
      return new Promise((resolve, reject) => {
        api.request('get', `${API_READ}${id}`)
          .then((result) => {
            // commit('read_single',{corporate:result.data.data});
            commit('success')

            return resolve(result.data.data);
          }).catch((err) => {
            commit('error');
            console.log(err.response.data);
            return reject(err.response.data)
          }).finally(() => {
            // page.isLoading = false;
          });
      })
    },
    update({ commit }, { data }) {


      commit('request');
      return new Promise((resolve, reject) => {
        api.request('put', `${API_UPDATE}${data.id}`, {}, data)
          .then((response) => {
            commit('success');
            return resolve(response);
          }).catch((err) => {

            commit('error')

            return reject(err);

          }).finally(() => {

          });
      })
    },
    create({ commit }, { data }) {
      // console.log({id})

      commit('request');

      return new Promise((resolve, reject) => {
        api.request('post', `${API_CREATE}`, {}, data)
          .then((response) => {
            commit('success');
            return resolve(response)
          }).catch((err) => {
            commit('error')
            return reject(err)

          }).finally(() => {
          });
      })

    },
    read_corp_logo({ commit }, id) {

      commit('request');
      return new Promise((resolve, reject) => {
        api.request('get', `${API_READ_LOGO}${id}`)
          .then((result) => {
            commit('success')
            return resolve(result.data.data);
          }).catch((err) => {
            commit('error', { message: err })
            return reject(err);
          });
      });
    },
    readAll({ commit, state }) {
      commit('request');
      const { meta } = state
      const { filter } = state
      const { search } = state

      return new Promise((resolve, reject) => {
        api.request('get', `${API_READ}all`, { meta, filter, search })
          .then((result) => {
            commit('read', { corporates: result.data.data })
            commit('success')

            commit('switch_page', { meta: { ...result.data.meta } })
            return resolve()
            // }).catch((err) => {
          }).catch((err) => {
            commit('error')
            return reject(err)
          }).finally(() => {
          });
      })
    },
    /**
     * Read corporates for dropdown with minimum limit of 50 and search support
     * @param {Object} context - Vuex context
     * @param {Object} options - Optional search parameters { searchName: string }
     */
    readForDropdown({ commit }, options = {}) {
      commit('request');
      const meta = {
        page: 1,
        limit: 50,
        total: 1
      }
      const search = options.searchName ? { name: options.searchName } : {}

      return new Promise((resolve, reject) => {
        api.request('get', API_READ, { meta, search })
          .then((result) => {
            commit('read', { corporates: result.data.data })
            commit('success')
            return resolve(result.data.data)
          }).catch((err) => {
            commit('error')
            return reject(err)
          });
      })
    },
  },
  getters: {
    corporates: () => state => state.corporates,
  }
}
